var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component"},[_c(_vm.editorTag,{tag:"component",domProps:{"innerHTML":_vm._s(_vm.valueText)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }